import { render, staticRenderFns } from "./CompanionTopicCard.vue?vue&type=template&id=db3771a2&scoped=true&lang=pug&"
import script from "./CompanionTopicCard.vue?vue&type=script&lang=js&"
export * from "./CompanionTopicCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanionTopicCard.vue?vue&type=style&index=0&id=db3771a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3771a2",
  null
  
)

export default component.exports